import styles from './Ourdev.module.css';

import React from 'react'
import { Col, Container, Row, CardGroup, Card, Button } from 'react-bootstrap';
import arrow from '../../assets/icons/arrow.png';
import img1 from '../../assets/imgs/cimg1.png';
import img2 from '../../assets/imgs/cimg2.png';
import img3 from '../../assets/imgs/cimg3.png';
import img4 from '../../assets/imgs/cimg4.png';
import img5 from '../../assets/imgs/cimg5.png';



export const OurDev = () => {
  return (
    <div>
        <Container fluid className={`${styles.cont}`}>
            <Row >
                <Col lg={6} sm={12} xs={12} md={6}>
                <div>
                    <h2 className={`${styles.title}`}> Smiling faces of ULLWEB Developers</h2>
                    <p className={`${styles.desc}`}>Amazing talents waiting to help you get online in few days for far less fraction of their usual fee</p>
              <Button variant='primary' className={`${styles.btn1}`}> See more developers <img src={arrow} /></Button>
                </div>                
                </Col>
                <Col lg={6} sm={12} xs={12} md={6}>
                {/* <div> */}
                     <Col >
                        <Card className={` ${styles.card1}`}>
                            <Card.Img src={img1} className={` rounded-circle ${styles.cardimg}`} />
                            <Card.Title className={`${styles.CardTitle}`}>Leslie Morgan</Card.Title>
                            <Card.Text className={`${styles.Cardtext1}`} >Mobile App Developer</Card.Text>
                        </Card>
                        </Col>

                        <Col>
                        <Row lg={2} xs={1} sm={1} md={2} className={`${styles.cardg}`}>

                        <Card className={` ${styles.card}`}>
                            <Card.Img src={img2} className={` rounded-circle ${styles.cardimg}`} />
                            <Card.Title className={`${styles.CardTitle}`}>Blessing Duru</Card.Title>
                            <Card.Text className={`${styles.Cardtext2}`} >Product Designer</Card.Text>
                        </Card>

                        <Card className={`mt-lg-5  ${styles.card}`}>
                            <Card.Img src={img3} className={` rounded-circle ${styles.cardimg}`} />
                            <Card.Title className={`${styles.CardTitle}`}>Omolola Glory</Card.Title>
                            <Card.Text className={`${styles.Cardtext3}`} >Back-end Developer</Card.Text>
                        </Card>

                        <Card className={`${styles.card2}`}>
                            <Card.Img src={img4} className={` rounded-circle ${styles.cardimg}`} />
                            <Card.Title className={`${styles.CardTitle}`}>Adebayo Johnson</Card.Title>
                            <Card.Text className={`${styles.Cardtext4}`} >Front-end Developer</Card.Text>
                        </Card>

                        <Card className={`${styles.card}`}>
                            <Card.Img src={img5} className={` rounded-circle ${styles.cardimg}`} />
                            <Card.Title className={`${styles.CardTitle}`}>Samuel Chuku</Card.Title>
                            <Card.Text className={`${styles.Cardtext5}`} >Product Manager</Card.Text>
                        </Card>
                        </Row>
                        </Col>
              <Button variant='primary' className={`${styles.btn1m}`}> See more developers <img src={arrow} /></Button>

                        </Col>

                               
            </Row>
        </Container>
    </div>
  )
}
